export default {
  tabs: {
    loan_applications: "Histórico Empréstimos",
    opt_in: "Outras Autorizaçōes"
  }
}